import { Box, Card, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { VisitInfoCardFragment } from "../../../../components/VisitInfoCard/fragments.generated";
import { VisitInfoCardContent } from "../../../../components/VisitInfoCard/VisitInfoCardContent";

type Props = {
    visit: VisitInfoCardFragment;
};

export default function FinalReportVisitCard({ visit }: Props) {
    const { t } = useTranslation("project");

    return (
        <Card sx={{ padding: 2 }} variant="outlined">
            <Stack direction="row" columnGap={2}>
                <Stack flex={2} rowGap={2}>
                    <Stack>
                        <Typography variant="caption" textTransform="uppercase">
                            {visit.plannerArea.project.client.name}
                        </Typography>
                        <Typography variant="h5">{visit.plannerArea.project.name}</Typography>
                        <Typography>{visit.plannerArea.name}</Typography>
                    </Stack>
                    <Stack>
                        <Typography>{visit.protocol.name}</Typography>
                        <Typography>
                            {t("projectReviewVisitV2.finalReportRoute.finalReportVisitCard.visitNumber")}:{" "}
                            {visit.protocolVisit.name ? visit.protocolVisit.name : visit.protocolVisit.number}
                        </Typography>
                    </Stack>
                </Stack>
                <Box flex={1}>
                    <VisitInfoCardContent visit={visit} showOpenPlannerButton={false} />
                </Box>
            </Stack>
        </Card>
    );
}
